import React, { useContext } from 'react';
import { GlobalContext } from '../../contexts/GlobalContext';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import PageTitle from '../../components/PageTitle/PageTitle';
import Accordion from '../../components/Accordion/Accordion';


const LGPD = () => {
    const { state } = useContext(GlobalContext);
    const language = state.language || 'pt-br';
    const data = require(`../../assets/languages/${language}/LGPD.json`);
    const {
        breadcrumb,
        selectedPage,
        pageTitle,
        itens,
        // intro
        questions
    } = data

    return (
        <>
            <Breadcrumb
                beforeRoutes={breadcrumb}
                selectedPage={selectedPage}
                ignoreMgBot={true}
            />
            <div className='main-container'>
                <section className="section-container">
                    <PageTitle title={pageTitle} />
                    {/* <span className='mg-bot-70' dangerouslySetInnerHTML={{ __html: intro }}></span> */}
                    {itens?.map((d, i) => {
                        return (
                            <>
                                <span className='text-title-secondary'>{d.label}</span>
                                <span dangerouslySetInnerHTML={{ __html: d.value }} className={`mg-bot-${i + 1 === itens.length ? '100' : '70'}`}></span>
                            </>
                        )
                    })}
                    <span className='text-title-secondary'>{questions.title}</span>
                    {
                        questions.itens.map((d, i) => (
                            <Accordion
                                key={i}
                                title={d.question}
                                backgroundColorContent={'var(--white100)'}
                                contentColor={'var(--gray300)'}
                                paddingContent={'30px 25px'}
                                isOpenBoxShadow={true}
                            >
                                <div dangerouslySetInnerHTML={{ __html: d.response }}>
                                </div>
                            </Accordion>
                        ))
                    }

                </section>
            </div>
        </>
    )
}

export default LGPD